import React, { useEffect, useState } from 'react'
import styles from './style/switch_style.module.scss';
import PropTypes from 'prop-types';
import Icon, { ICON_PROPTYPES } from '../../foundations/icon/Icon'

const DEFAULT_SIZE = "24"

const Switch = ({ children, className = '', ...props }) => {


    const [selected, setSelected] = useState(1)

    const switchSelection = (fn, _selected) => {
        if (_selected !== selected) {
            setSelected(_selected)
            fn()
        }
    }

    return (
        <div className={`${styles.switch} ${className}`}>
            <div className={selected === 1 ? styles.selected : styles.unselected} onClick={() => switchSelection(props.onClickA, 1)} >
                <Icon img={props.img1} size={props.size}/>
            </div>
            <div className={selected === 2 ? styles.selected : styles.unselected} onClick={() => switchSelection(props.onClickB, 2)} >
                <Icon img={props.img2} size={props.size}/>
            </div>
        </div>
    );
};

Switch.propTypes = {
    size: ICON_PROPTYPES.size,
    onClickA: PropTypes.func.isRequired,
    onClickB: PropTypes.func.isRequired,
    img1: ICON_PROPTYPES.img,
    img2: ICON_PROPTYPES.img,
};

Switch.defaultProps = {
    size: DEFAULT_SIZE
}

export default Switch;
